module.exports = __webpack_public_path__ + "img/agents_state_fr.88fa1435.svg";